<template>
  <b-modal
    id="modal-multi-3"
    size="sm"
    title="Confirmación"
    ok-only
    ok-title="Accept"
    v-model="$store.state.someVariables.showDeleteFixture"
  >
    <b-card-text class="my-1">
      El Fixture y sus valores asociados serán eliminados
      <br />
      ¿ Deseas continuar ?
    </b-card-text>

    <template #modal-footer>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        class="float-right mr-1"
        @click="close"
      >
        Cancelar
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="float-right"
        @click="saveAccion"
      >
        Aceptar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BCardText, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  //   ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    BCardText,
    BButton,
  },
  directives: {
    // 'b-popover': VBPopover,
    // heightFade,
    Ripple,
  },
  props: {
    dataEliminar: Object,
    action: String,
    movimiento: String,
  },
  setup(props, { emit }) {
    const { postApi } = apiCall()

    async function deletePlayer() {
      // console.log(props)
      const dataSend = {
        id_categoria: props.dataEliminar.id_categoria,
        etapa: props.dataEliminar.etapa,
        grupo: props.dataEliminar.grupo,
        id_campeonato: props.dataEliminar.id_campeonato,
        id_modalidad_grupo: props.dataEliminar.id_modalidad_grupo,
        idUserIngresa: USER().id_usuario,
        rol: USER().rol,
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      }
      const path = 'ApiFixture/deleteFixture'
      const response = await postApi(URL, path, dataSend)
      if (response.flag === 'si') {
        // console.log('eliminado')
        emit('eliminadoFixture')
      } else {
        emit('errorEliminar')
      }
      store.commit(
        'someVariables/UPDATE_SHOW_DELETE_FIXTURE',
        // eslint-disable-next-line
        false,
      )
    }

    function saveAccion() {
      deletePlayer()
    }

    function close() {
      store.commit(
        'someVariables/UPDATE_SHOW_DELETE_FIXTURE',
        // eslint-disable-next-line
        false,
      )
    }
    return {
      deletePlayer,
      close,
      saveAccion,
    }
  },
}
</script>
